import React from 'react'
import 'react-vis/dist/style.css'
import {
  RadarChart,
  makeWidthFlexible
} from 'react-vis'

const DATA = [
  { name: 'IN6001', nightvision: 7, megapixel: 1, power: 7, focal: 4.2, irleds: 4 },
  { name: 'IN3011', nightvision: 12, megapixel: 0.3, power: 7.6, focal: 6, irleds: 10 }
]

const FlexibleRadarChart = makeWidthFlexible(RadarChart)

export default class IN8015RadarIN6012 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      crosshairValues: []
    };
  }

  render() {
    return (
      <React.Fragment>

        <div className="chart">
          <FlexibleRadarChart
            data={DATA}
            startingAngle={0}
            domains={[
              { name: 'focal', domain: [4, 6] },
              { name: 'megapixel', domain: [0, 1] },
              { name: 'power', domain: [6, 8] },
              { name: 'nightvision', domain: [6, 12] },
              { name: 'irleds', domain: [3, 10] }
            ]}
            margin={{
              left: 50,
              right: 50
            }}
            width={400}
            height={275} />
        </div>

      </React.Fragment>
    );
  }
}